import { isLocalUrl } from '../localjs';

const ticketShape = `
<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" viewBox="0 0 46.85 40.59">
  
  <g id="Layer_1-2" data-name="Layer 1">
    <g>
      <path class="cls-1" d="M46.4,5.92c-.29-.45-.86-1.03-1.92-1.23l-3.74-.98-1.26-.32-.34,1.26s-.38,1.34-1.5,1.94c-.78.42-1.81.42-3.05,0l-.1-.03c-.24-.06-2.35-.72-2.21-3.96l.05-1.05-4.65-1.3c-1.07-.31-2.93-.02-3.64,2.03l-.53,1.54-.23-1.19c-.04-.24-.28-1.5-1.35-2.21-.45-.3-1.21-.59-2.26-.33l-3.81.65-1.28.23.2,1.29s.21,1.38-.57,2.39c-.54.7-1.48,1.12-2.78,1.26h-.1c-.25.05-2.44.33-3.64-2.69l-.39-.97-4.78.72C1.39,3.13-.18,4.16.02,6.32l.15,1.7.79,4.59h-.01s3.99,22.98,3.99,22.98l.18,1.23c.02.21.19,1.29,1.15,2.05.4.32,1.06.66,2.03.66.17,0,.35-.01.53-.03l12.17-2.07v.05s1.46-.26,1.46-.26l7.9,2.06v.05s4.08,1.02,4.08,1.02c.25.09.78.26,1.43.26.47,0,.99-.09,1.5-.36.63-.33,1.44-1.05,1.75-2.62l5.32-20.23.03-.1h0v-.04s.91-3.41.91-3.41h0s1.02-3.91,1.02-3.91l.34-1.45c.07-.24.36-1.48-.33-2.57ZM10.3,36.55l-1.83.33c-.48.05-.69-.06-.75-.4l-.19-1.3-3.14-18.12,2.94-.54-.38-2.07-2.92.54-.22-1.23h0s-1.04-6.03-1.04-6.03l-.15-1.64c-.03-.29.01-.44.25-.5l2.77-.42c1.72,3.18,4.61,3.62,6.06,3.36,2.05-.22,3.59-.99,4.58-2.3.79-1.05,1.05-2.2,1.11-3.07l2.74-.46.12-.03c.1-.03.16-.03.19-.03,0,0,.01,0,.01,0,.07.05.16.26.2.45l.28,1.48.92,5.51-.44,1.71-2.58.48.38,2.07,1.62-.3-4.37,16.97-.34,1.19c-.06.2-.35,1.26.21,2.34.14.27.36.59.7.88l-6.75,1.14ZM36.55,36.99l-.02.09c-.08.43-.23.73-.39.83-.22.12-.63.02-.77-.03l-2.08-.54v-.02s-5.84-1.53-5.84-1.53l-4.92-1.29-1.55-.41-1.8-.45c-.46-.15-.61-.34-.52-.67l.36-1.26,3.93-15.25.77-2.98,3.26.86.54-2.04-3.26-.86.32-1.24h0s1.41-5.48,1.41-5.48l.54-1.56c.09-.27.19-.4.43-.35l2.7.76c.26,3.61,2.72,5.19,4.15,5.56,1.96.64,3.68.57,5.12-.22,1.16-.63,1.86-1.58,2.27-2.34l2.68.7.12.02c.15.02.2.06.2.06.04.07.04.3,0,.49l-.35,1.47-1.8,6.83-2.83-.75-.54,2.04,2.84.75-4.95,18.82Z"/>
      <rect class="cls-1" x="10.46" y="13.33" width="5.27" height="2.11" transform="translate(-2.38 2.6) rotate(-10.41)"/>
      <rect class="cls-1" x="32.03" y="12.22" width="2.11" height="5.27" transform="translate(10.27 43.05) rotate(-75.2)"/>
    </g>
  </g>
</svg>
`;

export default function () {
  const widgetName = 'ticketButton';
  const widgetOpts = ticketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $widget.remove();
      } else {
        createCustomTicketBtn(data.items[0]);
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData;

    $widget.replaceWith(`
      <a class="ticket-button" href="${URL}" ${isLocalUrl(URL) ? '' : 'target="_blank"'} aria-label="${Title}" tabindex="0">
        <span class="tkt-icon">${ticketShape}</span>
        <span class="tkt-text">${Title}</span>
      </a>
      `);
  }
}
